import { AbstractControl } from '@angular/forms';
import { PortalFieldConfig } from '../type';

/**
 * Pure helper: determine whether a raw value is within optional range bounds.
 * Returns true when the value is considered valid (in-range) and false when out of range.
 * Behavior mirrors range validator: empty or non-numeric values are considered valid here.
 */
export function isInRangeValue(raw: unknown, range?: { min?: number; max?: number }): boolean {
  if (raw === null || raw === undefined || (typeof raw === 'string' && raw.trim() === '')) {
    return true; // empty -> considered valid (let required handle presence)
  }

  // raw is unknown; use String(raw) to safely coerce to a string for parsing
  const valueString = String(raw);
  const numeric = parseFloat(valueString.replace(/,/g, ''));
  if (isNaN(numeric)) {
    return true; // not a number -> this helper treats it as valid (validator can be combined with numeric enforcement)
  }

  let minVal = typeof range?.min === 'number' ? range.min : undefined;
  let maxVal = typeof range?.max === 'number' ? range.max : undefined;

  // swap if min > max
  if (typeof minVal === 'number' && typeof maxVal === 'number' && minVal > maxVal) {
    const t = minVal;
    minVal = maxVal;
    maxVal = t;
  }

  if (typeof minVal === 'number' && numeric < minVal) {
    return false;
  }
  if (typeof maxVal === 'number' && numeric > maxVal) {
    return false;
  }

  return true;
}

/**
 * Convenience wrapper: reads range from field.props.range and returns boolean.
 */
export function isInRange(control: AbstractControl, field: PortalFieldConfig): boolean {
  const range = field?.props?.range;
  return isInRangeValue(control?.value, range);
}
